export default __webpack_public_path__ + "static/media/rdig_logo.99b14d1d.jpg";